import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import ReactTooltip from 'react-tooltip'
import MenuItem from 'general/components/MeuItem/MenuItem.container'

import iconFlows from 'shared/assets/icons/menu-flows.svg'
import iconEntities from 'shared/assets/icons/menu-entities.svg'
import iconLibrary from 'shared/assets/icons/menu-library.svg'
import iconActions from 'shared/assets/icons/menu-actions.svg'
import iconVersions from 'shared/assets/icons/menu-versions.svg'
import iconIntegrations from 'shared/assets/icons/menu-integrations.svg'
import iconAnalyticsActive from 'shared/assets/icons/menu-analytics-active.svg'
import iconSettings from 'shared/assets/icons/menu-settings.svg'
import iconChat from 'shared/assets/icons/menu-chat.svg'
import iconCampaigns from 'shared/assets/icons/campaigns.svg'
import iconMenuPeople from 'shared/assets/icons/menu-people.svg'
import iconExpand from 'shared/assets/icons/menu-expand.svg'

import styles from './Menu.module.scss'

const menuItems = {
  first: [
    { tip: 'Flows', route: 'flows', icon: iconFlows },
    { tip: 'Intent Library', route: 'library', icon: iconLibrary },
    { tip: 'Entity types', route: 'entities', icon: iconEntities },
    { tip: 'Actions', route: 'actions', icon: iconActions }
  ],
  second: [
    { tip: 'Versions', route: 'versions', icon: iconVersions },
    { tip: 'Integrations', route: 'channels', icon: iconIntegrations },
    { tip: 'Audience', route: 'audience', icon: iconMenuPeople },
    { tip: 'Broadcasts', route: 'scheduler', icon: iconCampaigns }
  ],
  third: [
    { tip: 'Analytics Beta', route: null, icon: iconAnalyticsActive, active: true },
    { tip: 'Chat', route: 'chatapp', icon: iconChat }
  ]
}

const renderMenuItems = items => items.map((item, i) => (
  <MenuItem
    key={i}
    active={!!item.active}
    tip={item.tip}
    route={item.route}
    icon={item.icon}
  />
))

const Menu = props => {
  const {
    onToggleExpand,
    isSidebarMenuExpanded
  } = props

  return (
    <div className={classNames(styles.menu, isSidebarMenuExpanded && styles.menuExpanded)}>
      <div className={styles.top}>
        
        <div className={styles.primary}>
          {renderMenuItems(menuItems.first)}
        </div>
        
        <div className={styles.secondary}>
          {renderMenuItems(menuItems.second)}
        </div>
        
        <div className={styles.secondary}>
          {renderMenuItems(menuItems.third)}
        </div>
        
      </div>
      <div className={styles.bottom}>

        <MenuItem
          active={false}
          tip='Project settings'
          route='settings/project'
          icon={iconSettings}
        />
        
        <a
          className={classNames(
            styles.item,
            styles.link,
            isSidebarMenuExpanded && styles.itemExpanded
          )}
          onClick={onToggleExpand}
          data-for="menuTip"
          data-tip={
            isSidebarMenuExpanded
              ? 'Collapse menu'
              : 'Expand menu'
          }
        >
          <div className={classNames(isSidebarMenuExpanded && styles.itemDetails)}>
            <img
              src={iconExpand}
              className={classNames(
                styles.icon,
                isSidebarMenuExpanded && styles.itemDetailIcon,
                isSidebarMenuExpanded && styles.iconRotated
              )}
            />
            { isSidebarMenuExpanded &&
            <div
              className={classNames(
                styles.itemDetailLabel,
                isSidebarMenuExpanded && styles.itemDetailLabelExpanded
              )}
            >
              Collapse
            </div>
            }
          </div>
        </a>
      </div>
      { !isSidebarMenuExpanded &&
      <ReactTooltip
        place="right"
        type="dark"
        effect="solid"
        class='tooltip'
        id="menuTip"
        delayShow={400}
      />
      }
    </div>
  )
}

Menu.propTypes = {
  onToggleExpand: PropTypes.func.isRequired,
  isSidebarMenuExpanded: PropTypes.bool.isRequired
}

export default Menu
